export const transNumberToPicture = (num) => {
  if (!num) return;
  let arrNum = num.toString().split("");
  let arrPicNum = [];
  arrNum.forEach((element) => {
    switch (element) {
      case "1":
        arrPicNum.push("1.png");
        break;
      case "2":
        arrPicNum.push("2.png");
        break;
      case "3":
        arrPicNum.push("3.png");
        break;
      case "4":
        arrPicNum.push("4.png");
        break;
      case "5":
        arrPicNum.push("5.png");
        break;
      case "6":
        arrPicNum.push("6.png");
        break;
      case "7":
        arrPicNum.push("7.png");
        break;
      case "8":
        arrPicNum.push("8.png");
        break;
      case "9":
        arrPicNum.push("9.png");
        break;
      case "0":
        arrPicNum.push("0.png");
        break;
    }
  });
  return arrPicNum;
};
export const levelToPicture = (num) => {
  let pic = null;
  switch (num) {
    case 0:
      pic = require("@/assets/img/level1/lv0.png");
      break;
    case 1:
      pic = require("@/assets/img/level1/lv1.png");
      break;
    case 2:
      pic = require("@/assets/img/level1/lv2.png");
      break;
    case 3:
      pic = require("@/assets/img/level1/lv3.png");
      break;
    case 4:
      pic = require("@/assets/img/level1/lv4.png");
      break;
    case 5:
      pic = require("@/assets/img/level1/lv5.png");
      break;
    case 6:
      pic = require("@/assets/img/level1/lv6.png");
      break;
    case 7:
      pic = require("@/assets/img/level1/lv7.png");
      break;
    case 8:
      pic = require("@/assets/img/level1/lv8.png");
      break;
    case 9:
      pic = require("@/assets/img/level1/lv9.png");
      break;
    case 10:
      pic = require("@/assets/img/level1/lv10.png");
      break;
    case 11:
      pic = require("@/assets/img/level1/lv11.png");
      break;
    case 12:
      pic = require("@/assets/img/level1/lv12.png");
      break;
    case 13:
      pic = require("@/assets/img/level1/lv13.png");
      break;
    case 14:
      pic = require("@/assets/img/level1/lv14.png");
      break;
    case 15:
      pic = require("@/assets/img/level1/lv15.png");
      break;
    case 16:
      pic = require("@/assets/img/level1/lv16.png");
      break;
    case 17:
      pic = require("@/assets/img/level1/lv17.png");
      break;
    case 18:
      pic = require("@/assets/img/level1/lv18.png");
      break;
    case 19:
      pic = require("@/assets/img/level1/lv19.png");
      break;
    case 20:
      pic = require("@/assets/img/level1/lv20.png");
      break;
    case 21:
      pic = require("@/assets/img/level1/lv21.png");
      break;
  }
  return pic;
};

/**
 * 数字保留小数点位数
 * n 要处理的数字
 * size 保留小数点位数
 * */
export function fixedNumber(n, size = 2) {
  if (isNaN(n)) return n;
  const _n = n.toString();
  const arr = _n.split(".");
  if (arr[1]) {
    arr[1] = arr[1].substring(0, size);
  }
  return arr.join(".");
}
